import React from 'react';
import cls from '@utils/css-select';

import styles from './styles.scss';
import Section from 'components/section';
const cx = cls(styles);
const imgList1 = [
	'https://web-data.zmlearn.com/image/nKjLA5gyJ4SvQYsWpTPqBL/about_1%402x.png',
	'https://web-data.zmlearn.com/image/77TGQonsDs9JvDv521LUiS/about_2%402x.png',
	'https://web-data.zmlearn.com/image/b4fv5pgXtUjUTYDSvW1gzw/about_3%402x.png',
	'https://web-data.zmlearn.com/image/dvqrpzYGeo1SCUq8qGJjBR/about_4%402x.png',
];
const imgList2 = [
	'https://web-data.zmlearn.com/image/9vCL4KyYPmYecz9S7RXdqV/about_5%402x.png',
	'https://web-data.zmlearn.com/image/ko1WiyGCW4B6h1mkpiNcwG/about_6%402x.png',
	'https://web-data.zmlearn.com/image/gc8T6NsC9DYdbTuKhw9TgA/about_7%402x.png',
];
const article = [
	`AirClass, established in 2014, is a global education institution focusing on online one-on-one tutoring. The main business is to provide online one-on-one tutoring in mathematics, English, Science, Biology, Chemistry and other subjects for children aged 5-18. AirClass has been invested over $400 million USD in Sep 2020.`,
	`AirClass, is the world's largest one-on-one online tutoring service with more than 500,000 students worldwide, providing one-on-one targeted tutoring for young people around the world anytime, anywhere.  `,
	`Three levels ( SATS, GCSE and A-level ) of courses such as Maths, English, Science, Biology and Chemistry are currently offered in the UK. with an interview pass rate of 7.8%, the selection criteria for teachers are strict. All of teachers come from TOP30 universities in the UK and have rich teaching experience. Before they can formally teach , all of entry teachers need to undergo unified training and assessment. `,
	`The overall teaching process is a tutor + learning advisor model. The tutor is responsible for  full-time teaching and the learning advisor is in charge of supervising the learning progress , arranging lessons for students, and reviewing after class. In 2021, 91% of the students surveyed have improved significantly after undergoing 3 months of tutoring. `,
];
/**
 * AboutUS模块
 * @returns
 */
export default function AboutUs() {
	return (
		<div className={cx('about-us')}>
			<div className={cx('bg')} />
			<Section>
				<div className={cx('circle')} />
				<h3 className={cx('block-title', 'about-title')}>About us</h3>
				<div className={cx('img-list', 'upper', 'scroll-view')}>
					{imgList1.map((item, index) => (
						<img loading="lazy" key={index} src={item} alt="" />
					))}
				</div>
				<div className={cx('img-list', 'lower', 'scroll-view')}>
					{imgList2.map((item, index) => (
						<img loading="lazy" key={index} src={item} alt="" />
					))}
				</div>
				<article className={cx('article')}>
					{article.map((txt, index) => (
						<p key={index}>{txt}</p>
					))}
				</article>
			</Section>
		</div>
	);
}
